export function getOperatorName(operator) {
  return operator?.bonus?.operator_name || operator?.name;
}
